import { render } from "./EditOrientation.vue?vue&type=template&id=26be9340&scoped=true&ts=true"
import script from "./EditOrientation.vue?vue&type=script&lang=ts"
export * from "./EditOrientation.vue?vue&type=script&lang=ts"

import "./EditOrientation.vue?vue&type=style&index=0&id=26be9340&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26be9340"]])

export default __exports__